export default __webpack_public_path__ + "static/media/favicon.5f118789.png";